// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"672c34a7","453":"ab092e58"}[chunkId] + ".chunk.js";
};